import React, { useState } from "react";
import { useAuth } from "@/lib/auth";
import { useNavigate, Navigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [totp, setTotp] = useState("");
  const [needTotp, setNeedTotp] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password, totp || undefined);
    setLoading(false);
    if (res.ok) {
      navigate("/admin", { replace: true });
    } else if (res.needTotp) {
      setNeedTotp(true);
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md">
        <div className="mb-8">
          <div className="h-10 w-10 rounded-sm bg-primary text-primary-foreground flex items-center justify-center font-black text-lg mb-4">
            N
          </div>
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-2">
            // Backoffice
          </p>
          <h1 className="text-3xl font-black tracking-tight">Connexion administrateur</h1>
          <p className="text-sm text-muted-foreground mt-2">
            Accédez à la gestion du portail interne.
          </p>
        </div>

        <form onSubmit={submit} className="space-y-5" data-testid="login-form">
          <div>
            <Label htmlFor="email" className="text-xs uppercase tracking-wider">
              Email
            </Label>
            <Input
              id="email"
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@netkom.fr"
              className="mt-2 h-11"
              data-testid="login-email-input"
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs uppercase tracking-wider">
              Mot de passe
            </Label>
            <Input
              id="password"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 h-11"
              data-testid="login-password-input"
            />
          </div>
          {needTotp && (
            <div>
              <Label htmlFor="totp" className="text-xs uppercase tracking-wider">
                Code 2FA (6 chiffres)
              </Label>
              <Input
                id="totp"
                type="text"
                inputMode="numeric"
                pattern="[0-9]{6}"
                maxLength={6}
                required
                autoComplete="one-time-code"
                value={totp}
                onChange={(e) => setTotp(e.target.value.replace(/\D/g, ""))}
                placeholder="123 456"
                className="mt-2 h-11 font-mono tracking-widest text-center text-lg"
                autoFocus
                data-testid="login-totp-input"
              />
              <p className="text-xs text-muted-foreground mt-1">
                Saisissez le code affiché par votre application d&apos;authentification.
              </p>
            </div>
          )}
          {error && (
            <p className="text-sm text-destructive" data-testid="login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full h-11 rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 font-medium transition-colors disabled:opacity-60"
            data-testid="login-submit-button"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>

        <p className="text-xs text-muted-foreground mt-6 text-center">
          Identifiants par défaut : admin@netkom.fr / admin123
        </p>
      </div>
    </div>
  );
}
